import { AxiosResponse } from 'axios';

import { FetchCommunitiesRequestType } from './types';

import { CommonResponseType } from 'api/authApi';
import { GeneralResponseType } from 'common';
import { authServiceClient } from 'config';
import { CommunityType } from 'state';

export const fetchCommunitiesRequest = (params: FetchCommunitiesRequestType) => {
  return authServiceClient.get<
    GeneralResponseType<CommunityType>,
    AxiosResponse<GeneralResponseType<CommunityType>>,
    FetchCommunitiesRequestType
  >(`/community`, { params });
};

export const fetchCertainCommunityRequest = (id: string) => {
  return authServiceClient.get<CommunityType, AxiosResponse<CommunityType>>(
    `/community/${id}`,
  );
};

export const deleteCommunityRequest = (id: string) => {
  return authServiceClient.delete<CommonResponseType, AxiosResponse<CommonResponseType>>(
    `/community/${id}`,
  );
};

export const editCommunityRequest = (
  name: string,
  id: string,
  delta: number,
  companyId: string,
) => {
  return authServiceClient.put<
    CommonResponseType,
    AxiosResponse<CommonResponseType>,
    { name: string; delta: number; companyId: string }
  >(`/community/${id}`, { name, delta, companyId });
};

export const createCommunityRequest = (name: string, delta: number) => {
  return authServiceClient.post<
    CommunityType,
    AxiosResponse<CommunityType>,
    { name: string; delta: number }
  >(`/community`, { name, delta });
};
